interface Props {
  evaluated: number;
  total: number;
  status: string | null;
  errorMessage: string | null;
}

// Progresso do lote. Sem barra falsa: mostra "M de N sequências" porque é isso que o worker
// reporta — inventar percentual suave esconderia uma rodada travada.
export function SequenceProgress({ evaluated, total, status, errorMessage }: Props) {
  if (status === "FAILED" || status === "CANCELLED") {
    return (
      <div className="rounded-md border border-destructive/40 bg-destructive/5 p-3">
        <p className="text-sm text-destructive">
          {errorMessage ?? "A simulação da fila não foi concluída."}
        </p>
      </div>
    );
  }
  const done = total > 0 ? Math.min(100, Math.round((evaluated / total) * 100)) : 0;
  return (
    <div className="space-y-2 rounded-md border p-3">
      <p className="text-sm">
        Simulando a fila…{" "}
        <span className="text-muted-foreground">
          {total > 0 ? `${evaluated} de ${total} sequências` : "preparando"}
        </span>
      </p>
      <div className="h-1.5 overflow-hidden rounded-full bg-muted">
        <div
          className="h-full w-[var(--done)] bg-primary transition-[width] motion-safe:duration-500"
          style={{ "--done": `${done}%` } as React.CSSProperties}
        />
      </div>
      <p className="text-[10px] text-muted-foreground">
        Cada sequência roda a fila inteira no motor — leva alguns segundos por candidato.
      </p>
    </div>
  );
}
